import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where, } from 'firebase/firestore';
import { auth, db, } from '../firebase';
import { useParams } from 'react-router-dom';

export default function Poitemdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [poitems, setpoitems] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [updocid, setupdocid] = useState("");
    const { documentId } = useParams();


    const [productid, setproductid] = useState(" ");
    const [descreption, setdescreption] = useState(" ");
    const [size, setsize] = useState(" ");
    const [quantity, setquantity] = useState(0);
    const [rate, setrate] = useState(0);
    const [taxable, settaxable] = useState(0);
    const [gst, setgst] = useState(0);
    const [gstamount, setgstamount] = useState(0);
    const [total, settotal] = useState(0);

    const [products, setproducts] = useState([]);


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, "poitems"), where("poid", "==", documentId));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const fetchedItems = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setpoitems(fetchedItems);
            } else {
                console.log("No matching documents found!");
            }

            const q1 = query(collection(db, 'products'))
            onSnapshot(q1, (querySnapshot) => {
                setproducts(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });


        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = poitems.filter((item) =>
                item.data.avakpersonname.toUpperCase().includes(searchText.toUpperCase())
            );
            setpoitems(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleDelete = async (docid, poid) => {
        try {
            // Step 1: Delete the specific poitems entry
            const taskDocRef = doc(db, "poitems", docid);
            await deleteDoc(taskDocRef);

            // Step 2: Recalculate total from remaining poitems
            const poItemsQuery = query(collection(db, "poitems"), where("poid", "==", poid));
            const poItemsSnapshot = await getDocs(poItemsQuery);

            let newTotal = 0;
            poItemsSnapshot.forEach((doc) => {
                newTotal += parseFloat(doc.data().total) || 0;
            });

            // Step 3: Update the total in poregisters
            const poRegisterRef = doc(db, "poregisters", poid);
            await updateDoc(poRegisterRef, { pototal: newTotal });

            // Step 4: Show success message
            Toast.fire({
                icon: "success",
                title: "Item Deleted & Total Updated Successfully!",
            });

            fetchData1()

        } catch (error) {
            console.error("Error updating PO Register total:", error);
            Toast.fire({
                icon: "error",
                title: "Error updating PO total!",
            });
        }
    };


    const handleEdit = (id, productid, quantity, size, rate, descreption, taxable, gst, gstamount, total) => {
        setupdocid(id);
        setproductid(productid)
        setquantity(quantity)
        setsize(size)
        setrate(rate)
        setdescreption(descreption)
        settaxable(taxable)
        setgst(gst)
        setgstamount(gstamount)
        settotal(total)
    }

    const handleUpdate = async () => {
        try {
            let product = "";
            const docRef1 = doc(db, "products", productid);
            const docSnap1 = await getDoc(docRef1);

            if (docSnap1.exists()) {
                product = docSnap1.data().product;
            } else {
                product = " ";
            }

            // Step 1: Update the specific poitems document
            await updateDoc(doc(db, "poitems", updocid), {
                product: product,
                productid: productid,
                descreption: descreption,
                total: total,
                taxable: taxable,
                gst: gst,
                gstamount: gstamount,
                quantity: parseFloat(quantity),
                size: size,
                rate: rate,
            });

            // Step 2: Fetch all poitems related to the same avakRegisterId
            const q = query(collection(db, "poitems"), where("poid", "==", documentId));
            const querySnapshot = await getDocs(q);

            const poitemsArray = querySnapshot.docs.map(doc => ({
                ...doc.data()
            }));

            // Step 3: Calculate the total of all rates
            const allTotal = poitemsArray.reduce((sum, item) => parseFloat(sum) + (parseFloat(item.total) || parseFloat(0)), 0);

            // Step 4: Update poregisters with poitems array & allTotal
            const avakRegisterRef = doc(db, "poregisters", documentId);
            await updateDoc(avakRegisterRef, {
                poitems: poitemsArray,
                pototal: allTotal
            });

            // Step 5: Show success toast
            Toast.fire({
                icon: "success",
                title: "PO Items Updated Successfully!!"
            });

            // Step 6: Refresh data
            fetchData1();
        } catch (error) {
            console.error("Error updating documents:", error);
        }
    };


    const handleprodChange = (value) => {
        setproductid(value);
        setrate(0);
        setquantity(0);

    }

    // Function to Recalculate Values
    const calculateValues = (qty, r, g) => {
        // Ensure all values are numbers
        const qtyNum = parseFloat(qty) || 0;
        const rateNum = parseFloat(r) || 0;
        const gstNum = parseFloat(g) || 0;

        const newTaxable = qtyNum * rateNum;
        const newGstAmount = (newTaxable * gstNum) / (100); // Adjusted GST calculation
        const newTotal = newTaxable + newGstAmount;

        settaxable(newTaxable.toFixed(0));  // Round off values
        setgstamount(newGstAmount.toFixed(0));
        settotal(newTotal.toFixed(0));
    };


    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View  Items ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Sr No</th>
                                            <th>Product </th>
                                            <th>Descreption </th>
                                            <th>Quantity </th>
                                            <th>Size </th>
                                            <th>Rate </th>
                                            <th>Taxable </th>
                                            <th>Gst  </th>
                                            <th>Gst Amount </th>
                                            <th>Total </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            poitems.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.productid, item.quantity, item.size, item.rate, item.descreption, item.taxable, item.gst, item.gstamount, item.total)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id, item.poid) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.descreption}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.size}</td>
                                                    <td>{item.rate}</td>
                                                    <td>{item.taxable}</td>
                                                    <td>{item.gst}</td>
                                                    <td>{item.gstamount}</td>
                                                    <td>{item.total}</td>


                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}




            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit  Items</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <th style={{ padding: 10 }}>Product</th>
                                            <th style={{ padding: 10 }}>Description</th>
                                            <th style={{ padding: 10 }}>Size</th>
                                            <th style={{ padding: 10 }}>Quantity</th>
                                            <th style={{ padding: 10 }}> Rate</th>
                                            <th style={{ padding: 10 }}> Taxable</th>
                                            <th style={{ padding: 10 }}> GST</th>
                                            <th style={{ padding: 10 }}> GST Amount</th>
                                            <th style={{ padding: 10 }}> Total</th>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: 10 }}>
                                                <input
                                                    list="products-list"
                                                    className="form-control"
                                                    value={productid}
                                                    onChange={(e) => handleprodChange(e.target.value)}
                                                    placeholder="Select Product"
                                                />
                                                <datalist id="products-list">
                                                    {
                                                        products.map((item, index) => (
                                                            <option key={index} value={item.id}>{item.data.product}</option>
                                                        ))
                                                    }
                                                </datalist>
                                            </td>
                                            <td style={{ padding: 10 }}>
                                                <input type="text" value={descreption} onChange={(e) => setdescreption(e.target.value)} className="form-control" />
                                            </td>
                                            <td style={{ padding: 10 }}>
                                                <input type="text" value={size} onChange={(e) => setsize(e.target.value)} className="form-control" />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={quantity}
                                                    onChange={(e) => {
                                                        setquantity(e.target.value);
                                                        calculateValues(e.target.value, rate, gst);
                                                    }}
                                                    className="form-control"
                                                />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={rate}
                                                    onChange={(e) => {
                                                        setrate(e.target.value);
                                                        calculateValues(quantity, e.target.value, gst);
                                                    }}
                                                    className="form-control"
                                                />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={taxable}
                                                    readOnly
                                                    className="form-control"
                                                />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={gst}
                                                    onChange={(e) => {
                                                        setgst(e.target.value);
                                                        calculateValues(quantity, rate, e.target.value);
                                                    }}
                                                    className="form-control"
                                                />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={gstamount}
                                                    readOnly
                                                    className="form-control"
                                                />
                                            </td>

                                            <td style={{ padding: 10 }}>
                                                <input
                                                    type="number"
                                                    value={total}
                                                    readOnly
                                                    className="form-control"
                                                />
                                            </td>


                                        </tr>

                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
